import { get } from '../api.service';

export interface FreelancerParams {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface Freelancer {
  id?: number;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  signUpUser: {
    userId?: number;
    firstName?: string;
    email?: string;
    phoneNo?: string;
    organisation?: string;
    status?: string;
    isActive?: boolean;
  };
  reference?: string;
  orgNo?: string;
  accountType?: number;
  ssn?: string;
}

export interface FreelancerResponse {
  statusCode: number;
  message: string;
  response: Freelancer[];
  totalCount: number;
}

/**
 * Fetches all customers from the API.
 * Corresponds to: GET /api/customer
 * @returns The API response with freelancer data.
 */
export const fetchFreelancers = async (params?: FreelancerParams): Promise<FreelancerResponse> => {
  try {
    const response = await get('/freelancerv2?', {
      ...(params?.searchQuery && { searchQuery: params.searchQuery }),
      ...(params?.pageNumber && { pageNumber: params.pageNumber }),
      ...(params?.pageSize && { pageSize: params.pageSize }),
    });
    return response;
  } catch (error) {
    console.error('Error fetching freelancers:', error);
    throw error;
  }
};

/**
 * Fetches a single customer by ID.
 * @param customerId - The ID of the customer to fetch.
 * @returns The API response with customer data.
 */
export const fetchFreelancerById = async (freelancerId: number): Promise<Freelancer> => {
  try {
    const response = await get(`/freelancer/${freelancerId}`);
    return response;
  } catch (error) {
    console.error(`Error fetching freelancer with ID ${freelancerId}:`, error);
    throw error;
  }
};
